import I18n from 'i18n-js';
import React from 'react';

import PercentageBar from '@reverbdotcom/commons/src/components/percentage_bar';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { SHOP_PAGE } from '../shared/url_helpers';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import experiments from '@reverbdotcom/commons/src/experiments';

export interface IFreeShippingStatus {
  thresholdMet: boolean;
  percentProgress: number;
  amountRemainingDisplay: string;
  displayProgressBar: boolean;
  shopName: string;
  shopSlug: string;
}

const COMPONENT_NAME = 'FreeShippingProgressBar';

export function FreeShippingProgressBar({
  thresholdMet,
  percentProgress,
  amountRemainingDisplay,
  displayProgressBar,
  shopName,
  shopSlug,
}: IFreeShippingStatus) {

  const user = useUser();

  useViewTracking({
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
    shopSlug,
    freeShippingThresholdMet: thresholdMet,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.FSOX_MV_THRESHOLD,
    ]),
  }, true);

  if (!displayProgressBar) { return null; }

  return (
    <>
      <div className="bg-offwhite mb-1 bd-rounded">
        <PercentageBar animate percentage={percentProgress} color="green" />
      </div>
      {thresholdMet ? (
        <p className="weight-bold mb-0 lh-120">
          {I18n.t('discovery.cart.freeShippingThresholds.thresholdMet', { shopName })}
        </p>
      ) : (
        <SanitizedRender
          html={I18n.t(
            'discovery.cart.freeShippingThresholds.amountRemaining',
            {
              amountRemainingDisplay,
              shopName,
              tagOpen: `<a href="${SHOP_PAGE.expand({ slug: shopSlug })}" target="_blank">`,
              tagClose: '</a>',
            },
          )}
        />
      )}
    </>
  );
}

export default FreeShippingProgressBar;
